module.exports = __webpack_public_path__ + "files/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CVP.1ed18ec74f68697d05a72994e32469a5.pdf";